import * as React from 'react';
import { Link } from 'gatsby';
import styled, { useTheme } from 'styled-components';

import { margin, MarginProps } from '../../../components/styles';
import { Anchor, Flex, CardBox, Text, Tag } from '../../../components/blocks';

import { Blog } from '../../../@types/blog';
import Sample from '../../../images/sample.png';

type Props = MarginProps & {
  lists?: Blog.BlogData;
  title?: string;
  fill?: boolean;
};

const CaseList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: ${({ theme }) => theme.windowSizes.m};
  margin: 0 auto;
  gap: ${({ theme }) => theme.spaces.xl};

  ${({ theme }) =>
    theme.screen.min({
      gridTemplateColumns: '1fr',
      gap: theme.spaces.xxxl,
    })}
`;

const CoverImg = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: 50% 50%;
`;

const Root = styled(Flex)<Props>`
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxl};
  padding: ${({ theme, fill }) =>
    fill && `${theme.spaces.xxxl} ${theme.spaces.xl}`};
  background-color: ${({ theme, fill }) =>
    fill ? theme.backgroundColors.default : 'none'};
  ${margin}
`;

export const Case: React.FC<Props> = ({ lists, title, fill }) => {
  const { allMicrocmsBlog } = lists;
  const theme = useTheme();

  return (
    <Root fill={fill}>
      <Text as="h2" size="xxl" fontWeight="bold" textAlign="center">
        {title}
      </Text>
      <CaseList>
        {allMicrocmsBlog.edges.map(
          ({ node }: { node: Blog.MicrocmsBlog }, i) => (
            <CardBox key={node.id}>
              <Link to={`/blog/${node.blogId}`}>
                <CardBox.Img>
                  {node.key_visual ? (
                    <CoverImg
                      src={`${node.key_visual.url}?q=50&w=640`}
                      alt={node.title}
                      width="100%"
                      height="100%"
                    />
                  ) : (
                    <img
                      src={Sample}
                      alt={node.title}
                      width="100%"
                      height="100%"
                    />
                  )}
                </CardBox.Img>
                <CardBox.Contents>
                  <Flex
                    alignItems="flex-start"
                    flexDirection="column"
                    rowGap={theme.spaces.m}
                  >
                    <Text size="s" color="grey">
                      {node.publishedAt}
                    </Text>
                    <Text as="h2" fontWeight="bold" lineHeight="m">
                      {node.title}
                    </Text>
                    <Flex gap={theme.spaces.s} flexWrap="wrap">
                      {node.tags.map((tag: string) => (
                        <Tag
                          nowrap
                          key={tag}
                          color={
                            tag == '導入事例'
                              ? 'primary'
                              : tag == 'セミナーレポート'
                              ? 'green'
                              : tag == 'イベントレポート'
                              ? 'secondary'
                              : 'default'
                          }
                        >
                          {tag}
                        </Tag>
                      ))}
                      {node.category_case.map((category: string, i) => (
                        <Tag nowrap key={i}>
                          {category}
                        </Tag>
                      ))}
                    </Flex>
                  </Flex>
                </CardBox.Contents>
              </Link>
            </CardBox>
          ),
        )}
      </CaseList>
      <Anchor color="secondary" wide="l" radius="rounded" to="/case">
        他の導入事例を見る
      </Anchor>
    </Root>
  );
};
